import React, { useEffect } from "react";
import SearchBarComponent from "components/customs/searchbarV2";
import { defaultTableOption } from "constants/table";
import CustomDataTable from "components/customs/table";
import styled from "styled-components";
import CustomCongressmanSelection from "./Custom";
import AddEventColumns from "./columns";

const SearchbarWrapper = styled.div`
  width: 20%;
  position: relative;

  input {
    border: 2px solid ${({ theme }) => theme.colors.black60};
    background: white;
    box-shadow: none;
    border-radius: 9px;
    height: clamp(35px, 5vw, 50px);
  }
`;

const RecipientsTableContainer = styled.div`
  margin-bottom: 2rem;
`;

const RecipientsTableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 1rem;

  .custom-searchbar-container input {
    box-shadow: initial;
  }
`;

const RecipientsTable = styled.div`
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
  border-top: solid #cecece 1px;
  border-bottom: solid #cecece 1px;
`;

const TableHeader = styled.h5`
  margin: 0;
`;

const RecipientTable = ({
  data,
  action,
  setRecipients,
  recipients,
  isCustomSelected,
}) => {
  const [tableOption, setTableOption] = React.useState(defaultTableOption);

  let changeSearchTimeoutID;

  const onChangeSearch = (event) => {
    event.persist();

    if (changeSearchTimeoutID) {
      clearTimeout(changeSearchTimeoutID);
    }

    changeSearchTimeoutID = setTimeout(() => {
      const eventValue = event.target.value.trim();

      if (eventValue.length !== 0) {
        const dataTable = tableOption.data.filter(
          (item) =>
            item?.name?.toLowerCase()?.includes(eventValue) ||
            item?.designation?.toLowerCase()?.includes(eventValue) ||
            item?.area?.toLowerCase()?.includes(eventValue) ||
            item?.agency?.toLowerCase()?.includes(eventValue)
        );

        setTableOption({
          ...tableOption,
          data: dataTable,
        });
      } else {
        setTableOption({
          ...tableOption,
          data,
        });
      }
    }, 1000);
  };

  const columns = AddEventColumns({
    recipients,
    setRecipients,
    action,
  });

  useEffect(() => {
    if (data) {
      setTableOption({
        ...tableOption,
        data,
      });
    }
  }, [data]);

  return (
    <RecipientsTable>
      <RecipientsTableHeader>
        <TableHeader>{"Recipient Table"}</TableHeader>

        {!isCustomSelected && (
          <SearchbarWrapper>
            <SearchBarComponent
              onChangeSearch={onChangeSearch}
              isDisabled={tableOption?.isLoading}
            />
          </SearchbarWrapper>
        )}
      </RecipientsTableHeader>

      <RecipientsTableContainer>
        {!isCustomSelected ? (
          <CustomDataTable
            columns={columns}
            data={tableOption.data}
            noHeader
            progressPending={tableOption.isLoading}
            height="calc(100vh - 200px)"
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10, 25, 50, 100]}
          />
        ) : (
          <CustomCongressmanSelection
            action={action}
            setRecipients={setRecipients}
            recipients={recipients}
          />
        )}
      </RecipientsTableContainer>
    </RecipientsTable>
  );
};

export default RecipientTable;
